<template>
  <section class="section" style="padding-right: 0px; padding-left: 0px;">
    <b-tabs v-model="activeTab" position="is-centered" class="block is-danger">
      <b-tab-item class="remove-purple" v-for="schedule in schedules" :key="schedule.date" :label="schedule.date">
        <div class="container" style="max-width:1000px;">
          <div class=" columns is-multiline" v-if="schedule.workouts.length">
            <div class="column is-half" style="justify-items:center;" v-for="item in schedule.workouts"
              :key="item.time">
              <ScheduleBlock :obj="item" :date="schedule.date" :table="schedule.table" :content="content" />
            </div>
          </div>
          <div class="empty-schedule" v-else>
            <p class="title is-5"> {{content.empty_title}}</p>
            <p class="subtitle is-6">{{content.empty_text}}</p>
            <button class="button is-danger" @click="cardModal(schedule)"> {{content.empty_cta}} </button>
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
    <div class="empty-schedule" v-if="!schedules.length && init">
      <p class="title is-5"> No Schedule Available </p>
    </div>
  </section>
</template>

<script>
  import ScheduleBlock from './ScheduleBlock.vue'
  import axios from 'axios'
  import Form from './Form.vue'
  import trainers from '@/assets/trainers.json'


  export default {
    name: 'Schedule',
    components: {
      ScheduleBlock,
      Form
    },
    props: ['content'],
    created() {
      return axios.get("https://dvltomf8ih2to.cloudfront.net/schedules")
        .then(result => {
          let internal_schedule = result.data;
          this.schedules = internal_schedule.map(schedule => {
          const date = new Date(schedule.date.replace(/-/g, "/")).toLocaleString('en-US', {
                weekday: 'long',
                month: 'long',
                day: 'numeric'
              });
            return {
              date,
              table: schedule.date,
              workouts: schedule.workouts.map(workout => {
                return {
                  workout_id:workout.id,
                  full: workout.Full,
                  title: workout.Level + " Workout",
                  time: workout.Time,
                  nbr_rounds: workout.Rounds,
                  pic: trainers.find(trainer => {
                    return trainer.name === workout.Trainer
                  }).photo_url,
                  trainer: workout.Trainer,
                  duration: (workout.Rounds == "4 rounds") ? 25 : 
                            (workout.Rounds == "6 rounds") ? 35 : 
                            (workout.Rounds == "8 rounds") ? 40 : 
                            (workout.Rounds == "10 rounds") ? 50 : "-"
                };
              })
            }
          })
          this.init = true;
        })
    },
    data: function () {
      return {
        activeTab: 0,
        init: false,
        schedules: []
      }
    },
    methods: {
      cardModal(schedule) {
        //window.fbq('track','AddToWishlist')
        this.$modal.open({
          parent: this,
          component: Form,
          hasModalCard: true,
          props: {
            "obj": null,
            "date": schedule.date,
            "workout_id": schedule.workout_id,
            "content": this.content.form

          },
          canCancel: ['escape', 'outside']
        })
      }
    }

  }
</script>

<style scoped>
  .empty-schedule {
    margin: 100px 0px;
  }

  .b-tabs .tabs li.is-active a {
    border-bottom-color: red !important;
    color: red !important;
  }
</style>